import { useState } from 'react';
import { RxCheck, RxCross1 } from 'react-icons/rx';
import { Dialog, DialogContent, DialogTitle } from '@components/common/Dialog';

export const JobReviewForm = ({
    isOpen,
    onClose,
    wfmJobReviewData,
    setWfmJobReviewData,
    handleOnSubmit,
}) => {
    const [errors, setErrors] = useState({});

    const initialFormState = {
        target_date: '',
        department: '',
        vacancy_reason: '',
        duration_of_employment: '',
        role_budget_Salary: '',
        salary_currency: 'USD',
        sow_change_order_received: 'none',
    };

    const handleChange = e => {
        const { name, value } = e.target;
        setWfmJobReviewData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmitWithReset = async () => {
        if (wfmJobReviewData.sow_change_order_received === '') {
            setErrors({
                sow_change_order_received: 'Please select SOW or Change Order status',
            });
            return;
        }

        // Concatenate salary with currency
        const formattedData = {
            ...wfmJobReviewData,
            role_budget_Salary: `${wfmJobReviewData.role_budget_Salary} ${wfmJobReviewData.salary_currency}`,
        };

        // Clear errors if validation passes
        setErrors({});

        // Proceed with existing submit logic with formatted data
        await handleOnSubmit(formattedData);
        setWfmJobReviewData(initialFormState);
        onClose();
    };

    const handleCancel = () => {
        setWfmJobReviewData(initialFormState);
        onClose();
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="p-4 bg-white rounded-lg max-w-3xl">
                <DialogTitle className="text-xl font-bold mb-4">Job Review Form</DialogTitle>

                <form className="space-y-4">
                    <div className="grid grid-cols-3 gap-4">
                        <div>
                            <label className="block text-sm font-medium mb-1">Target Date</label>
                            <input
                                type="date"
                                name="target_date"
                                value={wfmJobReviewData.target_date}
                                onChange={handleChange}
                                className="w-full p-2 border rounded"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-1">Department</label>
                            <input
                                type="text"
                                name="department"
                                value={wfmJobReviewData.department}
                                onChange={handleChange}
                                className="w-full p-2 border rounded"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-1">Vacancy Reason</label>
                            <select
                                name="vacancy_reason"
                                value={wfmJobReviewData.vacancy_reason}
                                onChange={handleChange}
                                className="w-full p-2 border rounded"
                            >
                                <option value="">Select Reason</option>
                                <option value="new">New Growth</option>
                                <option value="replacement">Replacement</option>
                            </select>
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Duration of Employment
                            </label>
                            <input
                                type="text"
                                name="duration_of_employment"
                                value={wfmJobReviewData.duration_of_employment}
                                onChange={handleChange}
                                className="w-full p-2 border rounded"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium mb-1">
                                Role Budget Salary
                            </label>
                            <div className="flex gap-2">
                                <input
                                    type="number"
                                    name="role_budget_Salary"
                                    value={wfmJobReviewData.role_budget_Salary}
                                    onChange={handleChange}
                                    className="w-full p-2 border rounded"
                                />
                                <select
                                    name="salary_currency"
                                    value={wfmJobReviewData.salary_currency}
                                    onChange={handleChange}
                                    className="p-2 border rounded"
                                >
                                    <option value="USD">$ USD</option>
                                    <option value="GBP">£ GBP</option>
                                    <option value="ZAR">R ZAR</option>
                                    <option value="INR">₹ INR</option>
                                    <option value="BDT">৳ BDT</option>
                                    <option value="BGN">лв BGN</option>
                                </select>
                            </div>
                        </div>
                        <div className="">
                            <label className="block text-sm font-medium mb-2">
                                SoW/Change Order Status
                            </label>
                            <div className="space-y-2">
                                <label className="flex items-center">
                                    <input
                                        type="radio"
                                        name="sow_change_order_received"
                                        value="change_order"
                                        checked={
                                            wfmJobReviewData.sow_change_order_received ===
                                            'change_order'
                                        }
                                        onChange={handleChange}
                                        className="mr-2"
                                    />
                                    Change Order Received
                                </label>
                                <label className="flex items-center">
                                    <input
                                        type="radio"
                                        name="sow_change_order_received"
                                        value="sow"
                                        checked={
                                            wfmJobReviewData.sow_change_order_received === 'sow'
                                        }
                                        onChange={handleChange}
                                        className="mr-2"
                                    />
                                    SoW Received
                                </label>
                                <label className="flex items-center">
                                    <input
                                        type="radio"
                                        name="sow_change_order_received"
                                        value="none"
                                        checked={
                                            wfmJobReviewData.sow_change_order_received === 'none'
                                        }
                                        onChange={handleChange}
                                        className="mr-2"
                                    />
                                    None
                                </label>

                                {errors.sow_change_order_received && (
                                    <span className="text-red-500 text-sm">
                                        {errors.sow_change_order_received}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-span-3 space-x-4">
                        <button
                            type="button"
                            className="bg-blue-500 text-white px-4 py-2 rounded"
                            onClick={handleSubmitWithReset}
                        >
                            Submit
                        </button>
                        <button
                            type="button"
                            className="bg-gray-300 text-gray-700 px-4 py-2 rounded"
                            onClick={handleCancel}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </DialogContent>
        </Dialog>
    );
};
